import { Flex, Space, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import Images from "../../../../Images"
import { dateFormat, serviceImg, serviceMap } from "../../../../Utils/utils"

const { Text } = Typography

// The seven values of a row, shared by the table and the mobile card so the two never drift.

export const Customer = ({ alert }) => (
  <Flex vertical>
    <Text strong ellipsis>
      <Private>{alert?.customer_full_name || "—"}</Private>
    </Text>
    <Text type="secondary" ellipsis>
      <Private>{alert?.customer_email || "—"}</Private>
    </Text>
  </Flex>
)

export const TransactionId = ({ alert }) => {
  const ids = alert?.transaction_id
  if (!ids?.length) return "—"

  // First id only — the full list belongs to the alert's own screen.
  const [id] = ids
  const href = alert?.["transaction_link"]?.[0] || alert?.["transaction_url"]?.[0]

  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={(event) => event.stopPropagation()}>
      <Private>{id}</Private>
    </a>
  )
}

export const AlertSource = ({ alert, theme }) => {
  const service = alert?.alert_service

  return (
    <Space>
      <img src={Images[serviceImg?.[theme]?.[service]]} width={20} height={20} alt={service} />
      <Text>{serviceMap[service] || service || "—"}</Text>
    </Space>
  )
}

export const Amount = ({ alert }) => (
  <Text strong>
    <Private>
      {alert?.["converted_currency"]
        ? `${alert["converted_currency"]} ${alert["converted_amount"]}`
        : `${alert?.currency || ""} ${alert?.amount}`}
    </Private>
  </Text>
)

export const Card = ({ alert, theme }) => {
  const last4 = alert?.card_last4

  return (
    <Space>
      {alert?.brand && (
        <img
          src={Images[`${alert?.brand?.toLowerCase()}${theme === "dark" ? "_dark" : ""}`]}
          width={20}
          height={20}
          alt={alert?.brand}
        />
      )}
      {last4 ? (
        <Text>
          <Private mask="••••">
            {alert?.card_bin ? `${alert.card_bin} ••• ${last4}` : `•••• ${last4}`}
          </Private>
        </Text>
      ) : (
        "—"
      )}
    </Space>
  )
}

export const AlertDate = ({ alert }) => (
  <Text>{alert?.alert_timestamp ? dayjs(alert.alert_timestamp).format(dateFormat) : "—"}</Text>
)
